module.exports = __webpack_public_path__ + "img/2004_L.081ab548.png";